import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Space,
} from "antd";
import { useContext, useEffect, useState } from "react";
import GlobalContext from "../../../context/GlobalContext";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";
import { useLoader } from "../../../context/LoaderContext";
import { useTranslation } from "react-i18next";
import ModalAcceptFermeture from "./ModalAcceptFermeture";
import classes from "./modals.module.css";

const ModalFermereture = (props) => {
  const { openModalFermereture, setOpenModalFermereture, type } = props;
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const { form, globalData } = useContext(GlobalContext);
  const { setIsLoading } = useLoader();
  const { t } = useTranslation();
  const disabledDate = (current) => {
    return current && current < dayjs().add(15, "days").startOf("day");
  };

  const disabledDateReprise = (current) => {
    const fermeture = form.getFieldValue("dateFermeture");
     return current && fermeture && current <= fermeture.startOf("day").add(30, "days");

  };

  const handleSubmit = (values) => {
    setIsLoading(true);
    if(type==="en cours") {
      setIsLoading(true)
      const payload={
        date_reprise: values.dateReprise
          ? values.dateReprise.format("YYYY-MM-DD")
          : null,
        id_affaire:openModalFermereture
      }
      axiosInstance
      .post(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/update_date_reprise`,
        payload,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      ).then((response) => {
      setIsLoading(false)
      notification.success({
        message: t("Succès"),
        description: t("La date de reprise a été mise à jour avec succès."),
        duration: 0,
      });
      setOpenModalFermereture("");

      }).catch((error) => {
        setIsLoading(false)
        notification.error({
          message: t("Erreur"),
          description: t("Une erreur s'est produite lors de la mise à jour."),
          duration: 0,
        });
      })
      setOpenModalFermereture("");
      
    }
    else{
       axiosInstance
      .get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/check_existe_apprenants/${openModalFermereture}`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        if (response.data.existe) {
          notification.error({
            message: t("Erreur"),
            description: t(
              "Il y a des apprenants inscrits dans cet établissement. La fermeture n'est pas possible."
            ),
            duration: 0,
          });
          setOpenModalFermereture("");
        } else {
          setOpenConfirmModal(true);
          setOpenModalFermereture("");
        }
      }).catch((error) => {
        setIsLoading(false);
        notification.error({
          message: t("Erreur"),
          description: t("Une erreur s'est produite lors de la vérification."),
          duration: 0,
        });
      });
    }
   
  };


  useEffect(() => {
    if(type === "en cours"){
 form.setFieldsValue({
      typeFermeture: globalData?.date_reprise && globalData?.date_fermeture
        ? "provisoire"
        : "definitive",
      dateFermeture: dayjs(globalData?.date_fermeture,"YYYY-MM-DD"),
      dateReprise: dayjs(globalData?.date_reprise,"YYYY-MM-DD"),
      motif: "globalData?.motif",
    });
    }
   
  }, [globalData, form]);
  
  return (
    <>
      <Modal
        title="Choix du Nature de fermeture"
        open={openModalFermereture !== "" && !openConfirmModal}
        footer={false}
        onCancel={() => setOpenModalFermereture("")}
        style={{ textAlign: "center" }}
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ width: "100%" }}
          // initialValues={
          //   type === "en cours"
          //     ? {
          //         typeFermeture:
          //           globalData?.date_reprise && globalData?.date_fermeture
          //             ? "provisoire"
          //             : "definitive",
          //         dateFermeture: dayjs(globalData?.date_fermeture),
          //         dateReprise: dayjs(globalData?.date_reprise),
          //         motif: "motif",
          //       }
          //     : null
          // }
          disabled={type==="en cours"}
        >
          <span className={classes.natureText}>
            Merci de choisir la nature de fermeture de votre EPF.
          </span>
          <Form.Item
            label=""
            name="typeFermeture"
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner un type de fermeture",
              },
            ]}
            style={{ marginBlock: "1rem" }}
          >
            <Radio.Group>
              <Radio className={classes.radioStyle} value="definitive">
                Fermer l’EPF définitivement
              </Radio>
              <Radio className={classes.radioStyle} value="provisoire">
                Fermer l’EPF provisoirement
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Motif"
            name="motif"
            rules={[
              {
                required: true,
                message: "Veuillez saisir le motif de fermeture",
              },
            ]}
          >
            <Input.TextArea  />
          </Form.Item>

          <Form.Item
            shouldUpdate={(prev, curr) =>
              prev.typeFermeture !== curr.typeFermeture
            }
          >
            {() =>
              form.getFieldValue("typeFermeture") === "provisoire" && (
                <>
                  <Form.Item
                    label="Date de fermeture"
                    name="dateFermeture"
                    rules={[
                      {
                        required: true,
                        message: "Veuillez sélectionner la date de fermeture",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      disabledDate={disabledDate}
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>

                  <Form.Item

                    label="Date de reprise prévue"
                    name="dateReprise"
                    rules={[
                      {
                        required: true,
                        message:
                          "Veuillez sélectionner la date de reprise prévue",
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={false}
                      style={{ width: "100%" }}
                      format={"DD/MM/YYYY"}
                      disabledDate={disabledDateReprise}
                    />
                  </Form.Item>
                </>
              )
            }
          </Form.Item>

          <Space>
            <Button disabled={false} type="primary" onClick={() => setOpenModalFermereture("")}>
              {t("Annuler")}
            </Button>
            <Button type="primary" htmlType="submit" disabled={false}>
              {t("Confirmer")}
            </Button>
          </Space>
        </Form>
      </Modal>
      <ModalAcceptFermeture
        openConfirmModal={openConfirmModal}
        setOpenConfirmModal={setOpenConfirmModal}
        openModalFermereture={openModalFermereture}
        setOpenModalFermereture={setOpenModalFermereture}
      />
    </>
  );
};

ModalFermereture.propTypes = {
  openModalFermereture: PropTypes.bool,
  setOpenModalFermereture: PropTypes.func,
};

export default ModalFermereture;
